import { render, staticRenderFns } from "./planTip.vue?vue&type=template&id=2a7af223&scoped=true"
import script from "./planTip.vue?vue&type=script&lang=js"
export * from "./planTip.vue?vue&type=script&lang=js"
import style0 from "./planTip.vue?vue&type=style&index=0&id=2a7af223&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7af223",
  null
  
)

export default component.exports